import React from "react";

const LabNameImage = ({ labName }) => {
	return (
		<div
			style={{
				width: "100%",
				height: "120px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}>

			<div
				style={{
					padding: "10px",
					textAlign: "center",
					fontSize: labName && labName.length > 20 ? "14px" : "16px",
					fontWeight: "600",
					color: "#333333",
					lineHeight: "1.4",
					wordBreak: "break-word",
				}}>
				{labName || "Laboratório OG"}
			</div>
		</div>
	);
};

export default LabNameImage;